export { ErrorComponent } from '../components/error/error.component';
export type { ErrorResult } from '../components/error/error.component';
